<template>
  <div class="print__item">
    <div class="print__wr">
      <div class="calc__item calc__item-print">
        <!--        <div class="calc__head">-->
        <!--          <div class="calc__head_title">-->
        <!--            ПРОСЧЕТ <span>{{ name }}</span>-->
        <!--          </div>-->
        <!--        </div>-->
        <div class="calc__content">
          <div class="print__table">
            <div class="print__table_head">
              <div>№</div>
              <div>Товары (работы,услуги)</div>
              <div>Кол-во</div>
              <div>предоплата</div>
              <div>доплата (до доставки)</div>
              <div>стоимость</div>
            </div>
            <template v-for="cat in categoryList">
              <template v-if="currentItem[cat]">
                <PrintGoods
                  v-for="(item, index) in currentItem[cat].slice().reverse()"
                  :key="item.id"
                  :title="categoryName[cat]"
                  :item="item"
                  :index="index"
                  :category="cat"
                />
              </template>
            </template>
          </div>

          <table class="print__table print__table_total">
            <tr>
              <td>Предоплата:</td>
              <td>{{ formatPrice(prepay) }} руб</td>
            </tr>
            <tr>
              <td>Доплата (до доставки):</td>
              <td>{{ formatPrice(total - prepay) }} руб</td>
            </tr>
            <tr>
              <td>Итого:</td>
              <td>{{ formatPrice(total) }} руб</td>
            </tr>
            <tr>
              <td>НДС (не облагается):</td>
              <td>0</td>
            </tr>
          </table>
        </div>
      </div>
      <PrintManager v-if="false" />
    </div>
  </div>
</template>

<script>
import PrintManager from "@/components/Print-manager";
import ItemTemplate from "@/utils/ItemTemplate";
import wNumb from "wnumb";
import PrintGoods from "@/components/Print-goods";

export default {
  name: "Print-item",
  props: {
    currentItem: Object
  },
  // eslint-disable-next-line vue/no-unused-components
  components: { PrintGoods, PrintManager },
  computed: {
    categoryList() {
      return ItemTemplate.listCategory();
    },
    categoryName() {
      return ItemTemplate.namesCategory();
    },
    // currentItem() {
    //   return this.$store.getters.currentCalculation;
    // },
    name() {
      return this.currentItem?.name ?? "";
    },
    finalPrice() {
      return this.formatPrice((this.total * (100 - this.discount)) / 100);
    },
    total() {
      return this.currentItem?.total * this.coefficient;
    },
    coefficient() {
      return (
        (1 + this.$store.getters.currentOrder?.extra / 100) *
        (1 - this.discount / 100)
      );
    },
    discount() {
      return this.currentItem?.discount;
    },
    photo() {
      return this.currentItem?.photo;
    },
    prepay() {
      // return 9999;
      // Пройшовся по всі категоріям і виводжу суму предоплати
      return ItemTemplate.listCategory().reduce((acc, category) => {
        if (this.currentItem[category]) {
          return (
            acc +
            this.currentItem[category].reduce((acc, item) => {
              return acc + item.total * (item.prepay / 100);
            }, 0)
          );
        }
        return acc;
      }, 0);
    },
    prepayPercentages() {
      return Math.round((this.prepay / this.total) * 100) || 0;
    }
  },
  methods: {
    formatPrice(number) {
      return wNumb({
        decimals: 0,
        thousand: " "
      }).to(number);
    }
  }
};
</script>
